/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line unicorn/filename-case
import type { BlogDetail } from '../../../@types/gql/blog';
import type { StrapiBlog } from '../../../@types/gql/sidebar';
import Blogsidebar from '../sidebar';
import BlogDetails from './BlogDetails';

const DetailsContainer = ({
  sidebar,
  postDetails, 
}: {
  sidebar: StrapiBlog;
  postDetails: BlogDetail; 
}) => {
  console.log("data.strapiBlog",postDetails.BlogFaq)
  return (
    <div className="max-w-7xl px-6 mx-auto py-14">
      <div className="md:grid grid-cols-1 md:grid-cols-12 gap-5">
        <div className="col-span-8">
          <BlogDetails postDetails={postDetails} />
        </div>
        <div className="col-span-4 ">
          <div className='h-screen sticky top-[6rem]'>
          <Blogsidebar sidebar={sidebar} />
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default DetailsContainer;
